import { IndicatedRealizacaoItem } from "types/indicated";

interface Props {
  realizacao: IndicatedRealizacaoItem;
}

const RealizacaoCard: React.FC<Props> = ({ realizacao }) => {
  return (
    <div className="flex flex-col bg-[#3233bd] rounded-lg p-4 text-white">
      <div className="justify-start tag md:justify-end">
        {realizacao.categoria && <span>{String(realizacao.categoria)}</span>}
      </div>

      <h2 className="mt-3 mb-2 text-lg font-medium font-bb ">
        <strong>Realização: </strong>
        {realizacao.titulo}
      </h2>

      <div className="bg-white rounded-lg overflow-hidden text-black">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left px-4 py-2">Matrícula</th>
              <th className="text-left px-4 py-2">Nome</th>
            </tr>
          </thead>
          <tbody>
            {[...realizacao.indicados]
              .sort((a, b) => a.nome.localeCompare(b.nome))
              .map((inscrito) => (
              <tr key={inscrito.matricula} className="border-t">
                <td className="px-4 py-2">{inscrito.matricula}</td>
                <td className="px-4 py-2">{inscrito.nome}</td>
              </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RealizacaoCard;
